// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_benefit4_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Micro-movements rebuild muscles that rigid shoes let atrophy.`
};

const el_tech_benefit4_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Οι μικροκινήσεις αναδομούν μύες που τα άκαμπτα παπούτσια αφήνουν να ατροφήσουν.`
};

const ru_tech_benefit4_detail = /** @type {(inputs: {}) => string} */ () => {
	return `Микродвижения восстанавливают мышцы, которые атрофируются в жёсткой обуви.`
};

const he_tech_benefit4_detail = /** @type {(inputs: {}) => string} */ () => {
	return `תנועות מיקרו משקמות שרירים שנעליים נוקשות גורמות להם להתנוון.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_benefit4_detail = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_benefit4_detail(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_benefit4_detail", locale)
	if (locale === "en") return en_tech_benefit4_detail(inputs)
	if (locale === "el") return el_tech_benefit4_detail(inputs)
	if (locale === "ru") return ru_tech_benefit4_detail(inputs)
	if (locale === "he") return he_tech_benefit4_detail(inputs)
	return "tech_benefit4_detail"
};